import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCourierList } from '../../actions/admin';
import Select from '../../common/Form/Select';
import { debounce } from '../../utils/common';
import { CLEAR_COURIER_LIST_DROPDOWN_LIST_DATA } from '../../types/admin';
import { useFormContext } from 'react-hook-form';

const Courier = ({ name, label, onChange = () => { }, required = true, prefill = [] }) => {
    const dispatch = useDispatch();
    const courierListDropdown = useSelector((state) => state.admin.courierListDropdown);
    const isCourierListLoading = useSelector((state) => state.loading.isCourierListLoading);
    const methods = useFormContext();

    const getCourier = useCallback(({ limit = 100, page = 1, query = '', }) => {
        dispatch(getCourierList({ limit, page, query }));
    }, [dispatch]);

    const debouncedCourierListSearch = useCallback(debounce(getCourier), []);

    useEffect(() => {
        getCourier({ limit: 100, page: 1, query: '' });
    }, [getCourier]);

    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_COURIER_LIST_DROPDOWN_LIST_DATA });
        }
    }, [dispatch]);

    useEffect(() => {
        if (prefill && prefill.length > 0 && courierListDropdown && courierListDropdown.length > 0) {
            const find = courierListDropdown.find(option => prefill.includes(option.id));
            if (find && !methods.getValues(name)) {
                methods.setValue(name, find);
            }
        }
    }, [prefill, courierListDropdown]);

    return <Select
        name={name}
        label={label}
        options={courierListDropdown}
        isLoading={isCourierListLoading}
        required={required}
        shouldUnregister
        onChange={(event) => {
            const value = event?.value;
            onChange(value)
        }}
        onInputChange={(event) => {
            if (event.length > 0) {
                debouncedCourierListSearch({ query: event })
            }
        }}
    />
}

export default Courier;
